import { render, staticRenderFns } from "./BankIcon.vue?vue&type=template&id=5f49c992&scoped=true"
import script from "./BankIcon.vue?vue&type=script&lang=js"
export * from "./BankIcon.vue?vue&type=script&lang=js"
import style0 from "./BankIcon.vue?vue&type=style&index=0&id=5f49c992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49c992",
  null
  
)

export default component.exports